import { useField } from 'formik'
import { useCallback, MouseEvent, KeyboardEvent, Ref } from 'react'
import { Switch as AntdSwitch } from '../../Switch'
import type { SwitchProps as AntdSwitchProps } from '../../Switch'
import type { FormikFieldProps } from '../typings/FieldProps'

export type SwitchProps = FormikFieldProps &
  AntdSwitchProps & {
    ref?: Ref<HTMLButtonElement>
  }

export const Switch = ({
  name,
  onChange: onChangeProp,
  ref,
  ...restProps
}: SwitchProps) => {
  const [field, , helpers] = useField(name)
  const { value } = field
  const { setValue, setTouched } = helpers

  const handleChange = useCallback(
    (
      checked: boolean,
      event: MouseEvent<HTMLButtonElement> | KeyboardEvent<HTMLButtonElement>
    ) => {
      setValue(checked)
      onChangeProp?.(checked, event)
      setTimeout(() => setTouched(true), 0)
    },
    [onChangeProp, setTouched, setValue]
  )

  return (
    <AntdSwitch
      ref={ref}
      checked={value}
      onChange={handleChange}
      {...restProps}
    />
  )
}
